export const DEBUG = 0;
export const INFO = 1;
export const LOG = 2;
export const WARN = 3;
export const ERROR = 4;
export const GROUP = 5;
export const SILENCE = 6;

/**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6} LogLevel
 */
